import { render, staticRenderFns } from "./InternalOrdersTracker.vue?vue&type=template&id=70f19831&scoped=true"
import script from "./InternalOrdersTracker.vue?vue&type=script&lang=ts"
export * from "./InternalOrdersTracker.vue?vue&type=script&lang=ts"
import style0 from "./InternalOrdersTracker.vue?vue&type=style&index=0&id=70f19831&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f19831",
  null
  
)

export default component.exports